export const tools_PromoteEvents = [
	{
		icon: '👯‍♀️',
		title: 'toolsData_title1',
		subtitle: 'toolsData_subtitle1',
	},
	{
		icon: '💃🏻',
		title: 'toolsData_title2',
		subtitle: 'toolsData_subtitle2',
	},
	{
		icon: '👩‍💻',
		title: 'toolsData_title3',
		subtitle: 'toolsData_subtitle3',
	},
	{
		icon: '👩‍🎤',
		title: 'toolsData_title4',
		subtitle: 'toolsData_subtitle4',
	},
	{
		icon: '💁‍♀️',
		title: 'toolsData_title5',
		subtitle: 'toolsData_subtitle5',
	},
];
